import AddressContent from './AddressContent';
import { ConfirmDetailsSectionWrapper } from './ConfirmDetailsSectionWrapper';

const BillingDetails = ({ addressDetails = {}, openModal, ...props }) => (
  <ConfirmDetailsSectionWrapper
    displayDivider
    openModal={openModal}
    title="Billing Address"
    id="fs-billing-address-change"
    {...props}
  >
    <AddressContent {...addressDetails} />
  </ConfirmDetailsSectionWrapper>
);

export default BillingDetails;
